<template>
  <v-card class="text-xs-center">
    <h1 class="pa-3">STORE REGISTRATION</h1>
    <store-status-table :itemList="storeStatusList" />
  </v-card>
</template>

<script>
import storeStatusTable from "@/components/back-office/Merchant/StoreRegistration/StoreStatusTable.vue";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  async created() {},
  computed: {
    ...mapState({
      storeStatusList: (state) => state.fetchStoreApproveBack.storeStatusList,
    }),
  },
  methods: {
    ...mapActions({}),
  },
  components: { "store-status-table": storeStatusTable },
  destroyed() {
    this.$store.commit("fetchStoreApproveBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage",
      },
      {
        text: "Contact Store Approve",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/contactstoreapprove",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style>
</style>
